import { useEffect } from 'react';
import { isDev } from '../../../common/debug/utils';

const useRefetchOnVisibilityChange = (refetch: () => Promise<any>, hasPendingPayment: boolean) => {
  useEffect(() => {
    const visibilityChangeHandler = (event: Event) => {
      if (isDev || hasPendingPayment) {
        return Promise.resolve();
      }

      return event.target &&
        'visibilityState' in event.target &&
        event.target.visibilityState === 'visible'
        ? refetch()
        : Promise.resolve();
    };

    document.addEventListener('visibilitychange', visibilityChangeHandler);

    return () => document.removeEventListener('visibilitychange', visibilityChangeHandler);
  }, [hasPendingPayment, refetch]);
};

export default useRefetchOnVisibilityChange;
